import React, { useState, useEffect, useRef } from 'react';
import '../css/Login.css';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, signInAnonymously } from 'firebase/auth';
import { auth } from '../firebase';
import { useAuth } from '../AuthContext';
import ReCAPTCHA from 'react-google-recaptcha';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const navigate = useNavigate();
    const { user } = useAuth();
    const recaptchaRef = useRef();

    // Redirect if already logged in
    useEffect(() => {
        if (user) {
            setIsLoading(false);
            navigate('/bingo');
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError('Email and password are required.');
            return;
        }
        if (!recaptchaValue) {
            setError('Please complete the reCAPTCHA verification.');
            return;
        }
        setError('');
        setIsLoading(true);
        
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            setError('Invalid credentials. Please try again.');
            setIsLoading(false);
            recaptchaRef.current.reset();
            setRecaptchaValue(null);
        }
    };

    const handleGuestLogin = async () => {
        if (!recaptchaValue) {
            setError('Please complete the reCAPTCHA verification.');
            return;
        }
        setError('');
        setIsLoading(true);
        
        try {
            await signInAnonymously(auth);
        } catch (err) {
            setError('Something went wrong. Please try again.');
            setIsLoading(false);
            recaptchaRef.current.reset();
            setRecaptchaValue(null);
        }
    };

    const handleRecaptchaChange = (value) => {
        setRecaptchaValue(value);
        setError('');
    };

    return (
        <div className="register-container">
            <form className="register-form" onSubmit={handleSubmit}>
                <h2>Login</h2>
                {error && (
                    <>
                        <p className="error-message">{error}</p>
                        <Link to="/forgot-password" className="forgot-password-link">
                            Forgot Password?
                        </Link>
                    </>
                )}
                <label htmlFor="email">
                    Email:
                    <input 
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} 
                        disabled={isLoading}
                    />
                </label>
                <label htmlFor="password">
                    Password:
                    <input 
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} 
                        disabled={isLoading}
                    />
                </label>
                <div className="recaptcha-container">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LflciorAAAAAD3HwaioWqCOCH6Z3YmqrkO_8zLa"
                        //sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" // this is a test key
                        onChange={handleRecaptchaChange}
                    />
                </div>
                <button type="submit" disabled={isLoading || !recaptchaValue}>
                    {isLoading ? 'Logging in...' : 'Login'}
                </button>
                <button 
                    type="button" 
                    onClick={handleGuestLogin} 
                    className="guest-login"
                    disabled={isLoading || !recaptchaValue}
                >
                    {isLoading ? 'Logging in...' : 'Continue as Guest'}
                </button>
                <p>
                    Don't have an account? <Link to="/register">Register</Link>
                </p>
            </form>
        </div>
    );
};

export default Login;

